import { Dispatch, SetStateAction, useCallback } from "react";
import { useAsyncResult } from "../../Hooks/UseAsyncResult";
import { fetchExperimentPipelineMap } from "../../Api/ado.api";
import { useEv2ExperimentParams } from "../UseCurrentExtension";

/**
 * Hook to fetch the pipeline configuration for the current extension.
 * @param setError - Function to set error state in case of fetch failure.
 * @returns The pipeline configuration data or null if not found.
 */
export function useFetchPipelineConfig(
  setError: Dispatch<SetStateAction<any>>,
) {
  const { extensionFolder } = useEv2ExperimentParams();
  const func = useCallback(
    async (_disposable, _force) => {
      if (!extensionFolder) {
        return null;
      }
      let pipelineMap;
      const { rootExtension } = extensionFolder;
      try {
        const response = await fetchExperimentPipelineMap(rootExtension);
        pipelineMap = response;
      } catch (error) {
        console.error("Failed to fetch pipeline map:", error);
      }

      if (!pipelineMap) {
        return null;
      }

      return pipelineMap;
    },
    [extensionFolder],
  );

  return useAsyncResult({
    func,
    setError,
  });
}
